import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router, RouterOutlet } from '@angular/router';
import { KEYCLOAK_EVENT_SIGNAL, KeycloakEventType } from 'keycloak-angular';

import { ToastAlertComponent } from './common/toast-alert/toast-alert.component';
import { GlobalsService } from './shared/services/globals.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    ToastAlertComponent,
    MatProgressBarModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  private readonly globals = inject(GlobalsService);
  private readonly router = inject(Router);
  private readonly keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);

  protected readonly isManagedLoading = this.globals.isManagedLoading;
  protected readonly isOtherLoading = this.globals.isOtherLoading;

  constructor() {
    // Refresh-token expiry (idle SSO session outlives the page) otherwise fails
    // silently: keycloak.authenticated flips false, the bearer interceptor stops
    // attaching Authorization, and requests go out with no credential at all.
    effect(() => {
      if (this.keycloakSignal().type === KeycloakEventType.AuthRefreshError) {
        this.router.navigate(['/login']);
      }
    });
  }
}
